import React, { Component, Link } from "react";

class Logo extends React.Component {
  render() {
    return (
      <div className="caption_wrapper">
        <p className="caption_emphasized">
          Friseurmeisterin{" "}
          <span className="caption_emphasized_sub">
            Dominique Treder-Osigus
          </span>
        </p>
      </div>
    );
  }
}
export default Logo;
